import update from 'immutability-helper';
import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useCallback, useState } from 'react';
import { OrderItem } from './OrderItem';
import List from '@mui/material/List';

const OrderList = ({field,useFormRef,options,...props})=> {
  const {
    register,
    watch,
    setValue,
    resetField,
    formState: {errors}
  } = useFormRef;

  register(field);
  const list = watch(field);

  const [optionsMap, setOptionsMap] = React.useState(null);

  React.useEffect(()=> {
    const newOptionsMap = options.reduce((map,option)=>{
      map[option.id] = option.label;
      return map;
    },{});

    setOptionsMap(newOptionsMap);
  },[options]);

  const moveItem = useCallback((dragIndex, hoverIndex, listRef) => {
    const newList = update(listRef, {
      $splice: [
        [dragIndex, 1],
        [hoverIndex, 0, listRef[dragIndex]],
      ],
    });
    setValue(field, newList, { shouldDirty: true });
  });

  const renderItem = useCallback((id,text,listRef,index) => {
    return (
      <OrderItem
        key={id}
        index={index}
        id={id}
        text={text}
        moveItem={moveItem}
        listRef={listRef}
      />
    );
  }, []);

  return (
    <DndProvider backend={HTML5Backend}>
      { optionsMap && list &&
        <List>{list.map((id, i) => renderItem(id, optionsMap[id], list, i))}</List>
      }
    </DndProvider>
  );
};

export default OrderList;
